export default __webpack_public_path__ + "static/media/AdobeStock_311919226.5a812516.jpg";